import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function EmptyState({ restaurantId }) {
  const { t } = useTranslation();

  return (
    <div className="ri-empty" role="status">
      <div className="ri-empty-illustration" aria-hidden="true">
        <span className="ri-empty-icon" aria-hidden="true">🍽️</span>
      </div>
      <h2 className="ri-empty-title">{t('restaurant.info.notSet')}</h2>
      <p className="ri-empty-text">
        {t('restaurant.info.notSetDetail', 'The restaurant is working on adding their details. Check back later!')}
      </p>
      <Link to={`/menu/${restaurantId}`} className="ri-empty-btn">
        {t('restaurant.info.backToMenu')}
      </Link>
    </div>
  );
}
